(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

require('../../../modules/modules');

require('../../../templates/templates');

jQuery(document).ready(function ($) {
  outdatedBrowser({
    bgColor: '#f25648',
    color: '#ffffff',
    lowerThan: 'transform',
    languagePath: 'vendor/outdatedbrowser/lang/en.html'
  });
});

},{"../../../modules/modules":8,"../../../templates/templates":9}],2:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.popup-gallery').each(function () {
    $(this).magnificPopup({
      delegate: '.popup-gallery-link',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1]
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      }
    });
  });
});

},{}],3:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.popup-iframe-link').magnificPopup({
    type: 'iframe',
    midClick: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        wistia: {
          index: 'wistia.com/',
          id: '/medias/',
          src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    }
  });
});

},{}],4:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.popup-image-link').magnificPopup({
    type: 'image',
    midClick: true
  });
});

},{}],5:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.popup-link').magnificPopup({
    type: 'inline',
    midClick: true
  });
});

},{}],6:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.scroll-link').click(function (e) {
    e.preventDefault();
    $(this).blur();
    var string = $(this).attr('href').split('#')[1];
    $('#' + string).velocity('scroll', 400);
  });
});

},{}],7:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-header-nav-toggle').click(function (e) {
      e.preventDefault();
      if ($(this).data('is-open') === false) {
        $('.m-header-nav-nav').velocity('slideDown', {
          duration: 400
        });
        $(this).data('is-open', true);
      } else {
        $('.m-header-nav-nav').velocity('slideUp', {
          duration: 400
        });
        $(this).data('is-open', false);
      }
      $(this).toggleClass('is-active');
    });
  });
});

},{}],8:[function(require,module,exports){
'use strict';

require('./examples/popup/module-popup');

require('./examples/popup-gallery/module-popup-gallery');

require('./examples/popup-iframe/module-popup-iframe');

require('./examples/popup-image/module-popup-image');

require('./examples/scroll-link/module-scroll-link');

require('./header/module-header');

},{"./examples/popup-gallery/module-popup-gallery":2,"./examples/popup-iframe/module-popup-iframe":3,"./examples/popup-image/module-popup-image":4,"./examples/popup/module-popup":5,"./examples/scroll-link/module-scroll-link":6,"./header/module-header":7}],9:[function(require,module,exports){
"use strict";

},{}]},{},[1]);
